// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.adminPage {
    padding-top: 10px;
    /* padding-left: 20px; */
    justify-content: center;
    align-items: center;
    display: flex;
    flex-direction: column;
}

.addWorkForm {
    padding-top: 20px;
    width: 300px;
    display: flex;
    flex-direction: column;
}`, "",{"version":3,"sources":["webpack://./src/pages/Admin/Admin.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B","sourcesContent":[".adminPage {\n    padding-top: 10px;\n    /* padding-left: 20px; */\n    justify-content: center;\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n}\n\n.addWorkForm {\n    padding-top: 20px;\n    width: 300px;\n    display: flex;\n    flex-direction: column;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
